import api from "@/lib/api";

export interface PostIssueTrialRequest {
  productCode: string;
  deviceId: string;
  deviceEnv: string;
}

export interface PostIssueTrialResponse {
  serial: string;
}

export default {
  postIssueTrial(data: PostIssueTrialRequest) {
    return api<PostIssueTrialRequest, PostIssueTrialResponse>({
      endpoint: "trial-campaign/web-api/issue-trial",
      method: "POST",
      body: data
    });
  }
};
